function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#252737",
  fillRule: "evenodd",
  d: "M25.781 2.813c.219.843.375 2.125.469 3.843L26.297 9l-.047 2.344c-.094 1.75-.25 3.047-.469 3.89-.156.532-.437 1-.844 1.407a3.25 3.25 0 0 1-1.453.843c-.812.22-2.718.375-5.718.47L13.5 18l-4.266-.047c-3-.094-4.906-.25-5.718-.469a3.25 3.25 0 0 1-1.454-.843 3.269 3.269 0 0 1-.843-1.407C1 14.391.844 13.094.75 11.344L.703 9c0-.687.016-1.469.047-2.344.094-1.718.25-3 .469-3.843a3.25 3.25 0 0 1 .843-1.454A3.25 3.25 0 0 1 3.516.516C4.328.296 6.234.14 9.234.046L13.5 0l4.266.047c3 .094 4.906.25 5.718.469a3.25 3.25 0 0 1 1.453.843c.407.407.688.891.844 1.454zm-14.906 10.03L17.578 9l-6.703-3.797v7.64z"
});

var SvgYoutube = function SvgYoutube(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgYoutube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/youtube.7e62fc56.svg";
export { ForwardRef as ReactComponent };